import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "api/authApi";
import { pricingApi } from "api/pricingApi";
import { productApi } from "api/productApi";
import { orderApi } from "api/orderApi";
import { supplierApi } from "api/supplierApi";
import { shopifyApi } from "api/shopifyApi";
import { ebayApi } from "api/ebayApi";
import { dashboardApi } from "api/dashboardApi";
import { supportApi } from "api/supportApi";
import { invitationApi } from "api/invitationApi";

const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [pricingApi.reducerPath]: pricingApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [supplierApi.reducerPath]: supplierApi.reducer,
    [shopifyApi.reducerPath]: shopifyApi.reducer,
    [ebayApi.reducerPath]: ebayApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [invitationApi.reducerPath]: invitationApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(productApi.middleware)
      .concat(pricingApi.middleware)
      .concat(orderApi.middleware)
      .concat(supplierApi.middleware)
      .concat(shopifyApi.middleware)
      .concat(ebayApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(supportApi.middleware)
      .concat(invitationApi.middleware),
});

export default store;
